import { faker } from '@faker-js/faker';
import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay, requireAuth } from '@/test/mocks/utils';

import {
  InvoiceLinkResponse,
  InvoiceLinkErrorResponse,
} from './types/index.ts';

export const getInvoiceLink = (
  profile_id: string
): Promise<InvoiceLinkResponse> => {
  return axios.post(`/payments/v1/enrolment-credits-info`, { profile_id });
};

export const getInvoiceLinkMockHandler = http.post(
  `${env.API_URL}/payments/v1/enrolment-credits-info`,
  async ({
    cookies,
  }): Promise<HttpResponse<InvoiceLinkResponse | InvoiceLinkErrorResponse>> => {
    await networkDelay();
    const { error } = requireAuth(cookies);
    if (error) {
      return HttpResponse.json(
        {
          error: 'Internal server error',
          error_code: 'application-exception',
        },
        { status: 400 }
      );
    }

    const response: InvoiceLinkResponse = {
      payments: Array.from({
        length: faker.number.int({ min: 0, max: 2 }),
      }).map(() => {
        return {
          base_lead_id: faker.string.uuid(),
          profile_id: faker.string.uuid(),
          course: faker.string.numeric(2),
          course_name: faker.lorem.word(),
          variant_id: faker.string.uuid(),
          payment_variant_id: faker.string.uuid(),
          invoice_url: faker.internet.url(),
        };
      }),
    };

    return HttpResponse.json(response);
  }
);
